import Game from '../../../../Game';
import { Random } from '../../../../Utility/Random';
import {
    TActionType,
    TransactionType,
} from '../../../../Utility/Tracking/DataSet/Transaction';
import { trackTransaction } from '../../../../Utility/Tracking/TrackingHelpers/Transaction';
import { setCoins } from '../../../Player/PlayerInventoryHelper';
import { queuePopup } from '../../../UI/UIStateHelper';
import { IGameState } from '../../IGameState';
import { ICustomEntryPoint } from '../GameEntryPoint';

export function sendGift(payload: ICustomEntryPoint, state: IGameState) {
    const coins = Random.int(15, 25);
    state = {
        ...state,
        playerState: setCoins(
            state.playerState,
            state.playerState.coins + coins
        ),
        UIState: queuePopup(state.UIState, 'receiveCoinsFriendMenu', {
            title: Game.locale
                .getText('GotCoinsFrom')
                .replace('[x]', payload.userName),
            coins: coins,
        }),
    };
    trackTransaction(state, TransactionType.REWARD, TActionType.SOCIAL);
    return state;
}
